var $f1913fb7d1c187f8$exports = {};
$f1913fb7d1c187f8$exports = {
    "pending": `\u{5DE}\u{5DE}\u{5EA}\u{5D9}\u{5DF} \u{5DC}`
};


export {$f1913fb7d1c187f8$exports as default};
//# sourceMappingURL=he-IL.mjs.map
